import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatDropdown } from "blocks-nextjs/blocks-react/components/Dropdown/Dropdown";
import { CatList } from "blocks-nextjs/blocks-react/components/List/List";
import { CatListItem } from "blocks-nextjs/blocks-react/components/ListItem/ListItem";
import React from "react";
import useProjectDetailsStore from "../../store/useProjectDetailsStore";
import { formatDateWithTimezone } from "../../utils/dateFormatter";
const DateRangeDropdown = ({ className = "w-[25rem]", onValueChange, placeholder = "Sorting option(s)", selectedValue = "Last7Days", size = "sm" }) => {
    // Get timezone offset from project metadata
    const { projectMetaData } = useProjectDetailsStore((state) => ({
        projectMetaData: state.projectMetaData
    }));
    const timezoneOffset = projectMetaData?.offset || "UTC+00:00";
    // Calculate current date in project's timezone
    const getCurrentDateInTimezone = () => {
        const now = new Date();
        // Extract offset hours from format like "UTC+01:00" or "+09:00"
        const offsetStr = timezoneOffset.replace("UTC", "");
        const offsetMatch = offsetStr.match(/([+-])(\d{1,2}):?(\d{2})?/);
        if (offsetMatch) {
            const sign = offsetMatch[1] === "+" ? 1 : -1;
            const hours = parseInt(offsetMatch[2], 10);
            const minutes = parseInt(offsetMatch[3] || "0", 10);
            const totalOffsetMinutes = sign * (hours * 60 + minutes);
            // Get UTC time and apply project timezone offset
            const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
            const projectTime = new Date(utcTime + totalOffsetMinutes * 60000);
            return projectTime;
        }
        return now;
    };
    const today = getCurrentDateInTimezone();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const last7DaysStart = new Date(today);
    last7DaysStart.setDate(today.getDate() - 6);
    const last30DaysStart = new Date(today);
    last30DaysStart.setDate(today.getDate() - 29);
    const currentWeekStart = new Date(today);
    currentWeekStart.setDate(today.getDate() - today.getDay()); // Sunday
    // Current week ends today, not on Saturday
    const currentWeekEnd = new Date(today);
    const previousWeekStart = new Date(currentWeekStart);
    previousWeekStart.setDate(currentWeekStart.getDate() - 7);
    const previousWeekEnd = new Date(currentWeekStart);
    previousWeekEnd.setDate(currentWeekStart.getDate() - 1);
    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const formatDate = (date) => formatDateWithTimezone(date, timezoneOffset);
    const handleItemSelect = (value) => {
        if (onValueChange) {
            onValueChange(value);
        }
    };
    return (_jsx(CatDropdown, { ariaDescribedBy: "date-range-dropdown-field", className: className, "data-test": "date-range-dropdown", fieldId: "date-range-dropdown-field", placeholder: placeholder, size: size, value: selectedValue, children: _jsxs(CatList, { "data-test": "date-range-list", children: [_jsx(CatListItem, { "data-test": "date-range-item-today", onBlSelect: () => handleItemSelect("Today"), value: {
                        label: `Today (${formatDate(today)})`,
                        value: "Today"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-yesterday", onBlSelect: () => handleItemSelect("Yesterday"), value: {
                        label: `Yesterday (${formatDate(yesterday)})`,
                        value: "Yesterday"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-current-week", onBlSelect: () => handleItemSelect("CurrentWeek"), value: {
                        label: `Current Week (${formatDate(currentWeekStart)} - ${formatDate(currentWeekEnd)})`,
                        value: "CurrentWeek"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-previous-week", onBlSelect: () => handleItemSelect("PreviousWeek"), value: {
                        label: `Previous Week (${formatDate(previousWeekStart)} - ${formatDate(previousWeekEnd)})`,
                        value: "PreviousWeek"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-last-7-days", onBlSelect: () => handleItemSelect("Last7Days"), value: {
                        label: `Last 7 Days (${formatDate(last7DaysStart)} - ${formatDate(today)})`,
                        value: "Last7Days"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-last-30-days", onBlSelect: () => handleItemSelect("Last30Days"), value: {
                        label: `Last 30 Days (${formatDate(last30DaysStart)} - ${formatDate(today)})`,
                        value: "Last30Days"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-current-month", onBlSelect: () => handleItemSelect("CurrentMonth"), value: {
                        label: `Current Month (${formatDate(currentMonthStart)} - ${formatDate(today)})`,
                        value: "CurrentMonth"
                    } }), _jsx(CatListItem, { "data-test": "date-range-item-custom-date", onBlSelect: () => handleItemSelect("CustomDate"), value: {
                        label: "Custom Date",
                        value: "CustomDate"
                    } })] }) }));
};
export default DateRangeDropdown;
